import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { JpgOrPngConversionResponse } from '../../../../../../../shared/models/JpgOrPngConversionResponse';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { ConversionService } from '../../../../../../../shared/services/conversion.service';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { AiImageGenerationModel } from '../../models/ai-image-generation';
import { ImageResolutionModel, IMAGE_RESOLUTIONS } from '../../models/image-resolution';

import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { BackgroundRemovalModel, BackgroundRemovalResponseModel } from '../../models/background-remover';
import { NgForm } from '@angular/forms';
import { AiService } from '../../services/ai.service';
import { BlobService } from '../../../../../../../shared/services/blob.service';
type Tabs = 'Original' | 'Removed-background';
@Component({
  selector: 'app-background-remover',
    standalone:false,

  templateUrl: './background-remover.component.html',
  styleUrl: './background-remover.component.css',
})
export class BackgroundRemoverComponent implements OnInit {
  activeTab: Tabs = 'Original';
  fileError: string | null = null;
  allowedExtensions: string[] = ['jpg', 'png', 'jpeg'];
  backgroundRemovalRequestModel: BackgroundRemovalModel = new BackgroundRemovalModel();
  backgroundRemovalResponseModel:BackgroundRemovalResponseModel  = new BackgroundRemovalResponseModel();
  isLoading: boolean = false;
  imageUrl: string | ArrayBuffer | null = null;
  isDownloading: boolean = false;
  @ViewChild('bgRemoveForm') bgRemoveForm!: NgForm;
  bgRemoveSubscription!: Subscription;


  constructor(
    private aiService: AiService,
    private alertService: AlertService,
    public proxyServiceFetchURLService: ProxyServiceFetchURLService,
    private packService: PackService,
    private iconGalleryService: IconGalleryService,
    private cdr: ChangeDetectorRef,
   private blobService:BlobService,
  ) {}

  async ngOnInit() {
    this.preventBrowserDefaults();
  }


  onSelect(event: Event): void {
    this.fileError = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024*1024);
      if(fileSizeMB > 10){
        this.clear();
        this.fileError = 'File size exceeds 10MB. Please select a smaller file.';
        return;
      }
      if (fileExtension && this.allowedExtensions.includes(fileExtension)) {
        this.handleFileSelection(file);
      } else {
        this.backgroundRemovalRequestModel.image = null;
        this.bgRemoveForm.resetForm(this.backgroundRemovalRequestModel);
        this.fileError = `Invalid file type.Please select a valid file (${this.allowedExtensions.join(
          ','
        )}).`;
      }
    }
  }
  handleFileSelection(file: File): void {
    if (file) {
      this.backgroundRemovalRequestModel.image = file;
      const reader = new FileReader();
      reader.onload = (e) => (this.imageUrl = reader.result);
      reader.readAsDataURL(file);
      this.removeBackground();

    } else {
      this.backgroundRemovalRequestModel.image = null;
    }
  }

  get isValidFile(): boolean {
    if (!this.backgroundRemovalRequestModel.image) {
      return false;
    }
    const fileName = this.backgroundRemovalRequestModel.image.name.toLowerCase();
    return (
      fileName.endsWith(ImageFormat.Png.toString().toLowerCase()) ||
      fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase()) ||
      fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase())
    );
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.fileError = null;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fakeInputEvent = {
        target: { files: [file] },
      } as unknown as Event;
      this.onSelect(fakeInputEvent);
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  preventBrowserDefaults() {
    ['dragover', 'drop'].forEach((eventName) => {
      window.addEventListener(
        eventName,
        (e) => {
          e.preventDefault();
        },
        false
      );
    });
  }

  clear(): void {
    this.backgroundRemovalRequestModel.image = null;
    this.fileError = null;
    this.imageUrl = null;
    this.isLoading = false;
    this.isDownloading = false;
    this.activeTab = 'Original';
    this.backgroundRemovalResponseModel.base64_image='';
    this.backgroundRemovalResponseModel.content_type='';
    this.bgRemoveForm.resetForm();
    if (this.bgRemoveSubscription) {
      this.bgRemoveSubscription.unsubscribe();
    }
    this.cdr.detectChanges();
  }

  async removeBackground() {
    this.isLoading = true;
    this.fileError = null;
    this.activeTab = 'Removed-background';
    this.bgRemoveSubscription = await this.aiService
      .removeBackgroundImage(this.backgroundRemovalRequestModel)
      .subscribe({
        next: (data: BackgroundRemovalResponseModel) => {
          this.backgroundRemovalResponseModel = data;

          this.isLoading = false;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        },
        error: (err) => {
          this.isLoading = false;
          this.fileError = err?.error?.errors?.[0].message || err?.error?.errors?.[0].errors?.[0];
        },
      });
  }

  get getImageSource():string{
    return `data:${this.backgroundRemovalResponseModel.content_type};base64,${this.backgroundRemovalResponseModel.base64_image}` ;
  }

  async downloadImage() {
    this.iconGalleryService.downloadBase64(
      'img_bgRemove',
      this.backgroundRemovalResponseModel.base64_image,
      this.backgroundRemovalResponseModel.content_type.replace('image/','')
    );
    setTimeout(() => {
      this.isDownloading = false;
      this.cdr.detectChanges();
    }, 500);
  }

  setTab(tab: Tabs): void {
    this.activeTab = tab;
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab ? ' active' : '';
  }
  ngOnDestroy(): void {
    if (this.bgRemoveSubscription) {
      this.bgRemoveSubscription.unsubscribe();
    }
  }
}
